// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type EmployeeExternalAccount_EmployeeExternalAccountEloomi_Fragment = {
  __typename?: 'EmployeeExternalAccountEloomi';
} & Pick<
  Types.EmployeeExternalAccountEloomi,
  | 'email'
  | 'employeeId'
  | 'status'
  | 'accountType'
  | 'userType'
  | 'createdAt'
  | 'requestedAt'
  | 'canInvokeManualCreation'
>;

export type EmployeeExternalAccount_EmployeeExternalAccountGitHub_Fragment = {
  __typename?: 'EmployeeExternalAccountGitHub';
} & Pick<
  Types.EmployeeExternalAccountGitHub,
  | 'githubUsername'
  | 'email'
  | 'employeeId'
  | 'status'
  | 'accountType'
  | 'userType'
  | 'createdAt'
  | 'requestedAt'
  | 'canInvokeManualCreation'
>;

export type EmployeeExternalAccount_EmployeeExternalAccountGoogle_Fragment = {
  __typename?: 'EmployeeExternalAccountGoogle';
} & Pick<
  Types.EmployeeExternalAccountGoogle,
  | 'temporaryPassword'
  | 'changePasswordAtNextLogin'
  | 'aliases'
  | 'email'
  | 'employeeId'
  | 'status'
  | 'accountType'
  | 'userType'
  | 'createdAt'
  | 'requestedAt'
  | 'canInvokeManualCreation'
> & {
    licenses: Array<
      { __typename?: 'GoogleProductAndSKUWithDisplayName' } & Pick<
        Types.GoogleProductAndSkuWithDisplayName,
        'value' | 'displayName'
      >
    >;
  };

export type EmployeeExternalAccount_EmployeeExternalAccountGreenhouse_Fragment = {
  __typename?: 'EmployeeExternalAccountGreenhouse';
} & Pick<
  Types.EmployeeExternalAccountGreenhouse,
  | 'email'
  | 'employeeId'
  | 'status'
  | 'accountType'
  | 'userType'
  | 'createdAt'
  | 'requestedAt'
  | 'canInvokeManualCreation'
>;

export type EmployeeExternalAccount_EmployeeExternalAccountHubSpot_Fragment = {
  __typename?: 'EmployeeExternalAccountHubSpot';
} & Pick<
  Types.EmployeeExternalAccountHubSpot,
  | 'email'
  | 'employeeId'
  | 'status'
  | 'accountType'
  | 'userType'
  | 'createdAt'
  | 'requestedAt'
  | 'canInvokeManualCreation'
>;

export type EmployeeExternalAccount_EmployeeExternalAccountSlack_Fragment = {
  __typename?: 'EmployeeExternalAccountSlack';
} & Pick<
  Types.EmployeeExternalAccountSlack,
  | 'email'
  | 'employeeId'
  | 'status'
  | 'accountType'
  | 'userType'
  | 'createdAt'
  | 'requestedAt'
  | 'canInvokeManualCreation'
> & {
    workspace: Types.Maybe<
      { __typename?: 'EmployeeExternalAccountSlackWorkspace' } & Pick<
        Types.EmployeeExternalAccountSlackWorkspace,
        'teamId' | 'teamName'
      >
    >;
  };

export type EmployeeExternalAccountFragment =
  | EmployeeExternalAccount_EmployeeExternalAccountEloomi_Fragment
  | EmployeeExternalAccount_EmployeeExternalAccountGitHub_Fragment
  | EmployeeExternalAccount_EmployeeExternalAccountGoogle_Fragment
  | EmployeeExternalAccount_EmployeeExternalAccountGreenhouse_Fragment
  | EmployeeExternalAccount_EmployeeExternalAccountHubSpot_Fragment
  | EmployeeExternalAccount_EmployeeExternalAccountSlack_Fragment;

export type GetEmployeeExternalAccountQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;

export type GetEmployeeExternalAccountQuery = { __typename?: 'Query' } & {
  employee: Types.Maybe<
    { __typename?: 'Employee' } & {
      externalAccounts: Array<
        | ({
            __typename?: 'EmployeeExternalAccountEloomi';
          } & EmployeeExternalAccount_EmployeeExternalAccountEloomi_Fragment)
        | ({
            __typename?: 'EmployeeExternalAccountGitHub';
          } & EmployeeExternalAccount_EmployeeExternalAccountGitHub_Fragment)
        | ({
            __typename?: 'EmployeeExternalAccountGoogle';
          } & EmployeeExternalAccount_EmployeeExternalAccountGoogle_Fragment)
        | ({
            __typename?: 'EmployeeExternalAccountGreenhouse';
          } & EmployeeExternalAccount_EmployeeExternalAccountGreenhouse_Fragment)
        | ({
            __typename?: 'EmployeeExternalAccountHubSpot';
          } & EmployeeExternalAccount_EmployeeExternalAccountHubSpot_Fragment)
        | ({
            __typename?: 'EmployeeExternalAccountSlack';
          } & EmployeeExternalAccount_EmployeeExternalAccountSlack_Fragment)
      >;
    }
  >;
};

export const EmployeeExternalAccountFragmentDoc = /*#__PURE__*/ gql`
    fragment employeeExternalAccount on EmployeeExternalAccount {
  email
  employeeId
  status
  accountType
  userType
  createdAt
  requestedAt
  canInvokeManualCreation
  ... on EmployeeExternalAccountGoogle {
    temporaryPassword
    changePasswordAtNextLogin
    licenses {
      value
      displayName
    }
    aliases
  }
  ... on EmployeeExternalAccountSlack {
    workspace {
      teamId
      teamName
    }
  }
  ... on EmployeeExternalAccountGitHub {
    githubUsername
  }
}
    `;
export const GetEmployeeExternalAccountDocument = /*#__PURE__*/ gql`
    query getEmployeeExternalAccount($id: ID!) {
  employee(id: $id) {
    externalAccounts {
      ...employeeExternalAccount
    }
  }
}
    ${EmployeeExternalAccountFragmentDoc}`;

/**
 * __useGetEmployeeExternalAccountQuery__
 *
 * To run a query within a React component, call `useGetEmployeeExternalAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeExternalAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeeExternalAccountQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEmployeeExternalAccountQuery(
  baseOptions: Apollo.QueryHookOptions<GetEmployeeExternalAccountQuery, GetEmployeeExternalAccountQueryVariables> &
    ({ variables: GetEmployeeExternalAccountQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetEmployeeExternalAccountQuery, GetEmployeeExternalAccountQueryVariables>(
    GetEmployeeExternalAccountDocument,
    options,
  );
}
export function useGetEmployeeExternalAccountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetEmployeeExternalAccountQuery, GetEmployeeExternalAccountQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetEmployeeExternalAccountQuery, GetEmployeeExternalAccountQueryVariables>(
    GetEmployeeExternalAccountDocument,
    options,
  );
}
// @ts-expect-error
export function useGetEmployeeExternalAccountSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetEmployeeExternalAccountQuery,
    GetEmployeeExternalAccountQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetEmployeeExternalAccountQuery, GetEmployeeExternalAccountQueryVariables>;
export function useGetEmployeeExternalAccountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetEmployeeExternalAccountQuery, GetEmployeeExternalAccountQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetEmployeeExternalAccountQuery | undefined, GetEmployeeExternalAccountQueryVariables>;
export function useGetEmployeeExternalAccountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetEmployeeExternalAccountQuery, GetEmployeeExternalAccountQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetEmployeeExternalAccountQuery, GetEmployeeExternalAccountQueryVariables>(
    GetEmployeeExternalAccountDocument,
    options,
  );
}
export type GetEmployeeExternalAccountQueryHookResult = ReturnType<typeof useGetEmployeeExternalAccountQuery>;
export type GetEmployeeExternalAccountLazyQueryHookResult = ReturnType<typeof useGetEmployeeExternalAccountLazyQuery>;
export type GetEmployeeExternalAccountSuspenseQueryHookResult = ReturnType<
  typeof useGetEmployeeExternalAccountSuspenseQuery
>;
